export const gENConnectorStrs =
{
    "genericdomain1": "Domain",
    "genericdomain2": "Enter API domain",
    "genericsite1": "Site",
    "genericsite2": "Enter site",
    "genericcompany1": "Company",
    "genericcompany2": "Company cannot be blank",
    "genericsubdomain1": "Subdomain",
    "genericsubdomain2": "Enter API subdomain",
    "genericusername1": "Username",
    "genericusername2": "Enter API username",
    "genericpassword1": "Password",
    "genericpassword2": "Enter API password",
    "genericappid1": "App ID",
    "genericappid2": "Enter Application ID",
    "genericcommunity1": "Community",
    "genericcommunity2": "Enter Community",
    "genericapppass1": "App Password",
    "genericapppass2": "Enter Application Password",
    "genericclientid1": "Client ID",
    "genericclientid2": "Enter API client ID",
    "genericclientsecret1": "Client Secret",
    "genericclientsecret2": "Enter API client secret",
    "genericcompanyid1": "Company ID",
    "genericcompanyid2": "Enter API company ID",
    "genericclientkey1": "Client Key",
    "genericclientkey2": "Enter API client key",
    "genericqueryparams": "Query Params",
    "genericendpoint1": "API Endpoint",
    "genericendpoint2": "Enter API Endpoint",
    "genericapikey1": "API Key",
    "genericapikey2": "Enter API key",
    "genericapisecret1": "API Secret",
    "genericapisecret2": "Enter API secret",
    "genericresource1": "Resource",
    "genericresource2": "Enter resource",
    "generictenantid1": "Tenant ID",
    "generictenantid2": "Enter Tenant ID",
    "generictoken1": "API Token",
    "generictoken2": "Enter API Token",
    "genericport1": "Port Number",
    "genericport2": "Enter Port Number",
    "genericadditionaltables": "Additional Tables",
    "generictable": "Table",
    "genericusetable": "Use Table",
    "genericloaderr": "Query failed. Check connector configuration.",
    "genericstatus1": "Statuses",
    "sftphost1": "Host",
    "sftphost2": "Ex: sftp://example.orgchartnow.com",
    "sftpport1": "Port",
    "sftpport2": "If blank, defaults to 22",
    "sftpdirectory1": "Source path",
    "sftpdirectory2": "Ex: Sub Dir1/Sub dir 2/sub dir3",
    "sftpfilename1": "Filename",
    "sftpfilename2": "Ex: Test File.xls",
    "sftpusername1": "Username",
    "sftpusername2": "Ex: example_ex",
    "sftppassword1": "Password",
    "sftppassword2": "Password for your SFTP account.",
    "bamboo1": "Configure BambooHR Connection",
    "bamboo2": "Subdomain",
    "bamboo3": "API Key:",
    "bamboo3a": "Generate in your BambooHR profile",
    "bamboo4": "Report ID:",
    "bamboo4a": "Enter 0 for basic, 1 for extended",
    "bamboo5": "Include terminated employees",
    "bamboo6": "Custom Fields:",
    "bamboo6a": "Please click on the '?' for more information.",
    "bambooloaderr": "Query failed. Check BambooHR connector configuration.",
    "bamboocerr1": "Subdomain cannot be blank.",
    "bamboocerr2": "Report ID cannot be blank.",
    "bamboocerr3": "API Key must be exactly 40 chars.",
    "bambookey": "Retrieve API Key",
    "peopleHR1": "Configure PeopleHR Connection",
    "peopleHR2": "API Key",
    "peopleHR3": "Generate in PeopleHR",
    "peopleHR4": "Report ID",
    "peopleHR4a": "Enter 0 for basic, 1 for extended",
    "peopleHR5": "Query Name",
    "peopleHR6": "Enter Name of Query made in PeopleHR",
    "peopleHR7": "Use Query",
    "peopleHR8": "Query All Fields (includes sensitive data)",
    "peoplehrcerr1": "API Key cannot be blank.",
    "peoplehrcerr2": "Report ID cannot be blank.",
    "peoplehrloaderr": "Query failed. Check PeopleHR connector configuration.",
    "peoplehrloaderr2": "Authenication failed. Check PeopleHR connector configuration.",
    "peoplehrloaderr3": "Bad data returned. Check PeopleHR connector configuration.",
    "peoplehrloaderr4": "No employee records returned.",
    "adpoid": "ADP OID",
    "adpHR1": "Configure ADP Connection",
    "Client ID:": "Client ID:",
    "adpHR2a": "Click on the Retrieve Keys button",
    "Client Secret:": "Client Secret:",
    "adpHR4": "Click on the Retrieve Keys button",
    "adpHR5": "Custom Fields:",
    "adpHR5a": "Click on the ? for more information",
    "adpHR6": "Report ID:",
    "adpHR6a": "Enter 0 for basic, 1 for extended",
    "adpHR10": "Query",
    "adpHR10a": "Leave blank for default query",
    "adpHR7": "Interface:",
    "adpHR8": "Include custom fields",
    "adpHR9": "Optimized Server",
    "adpHR11": "Include photo field",
    "adpkey": "Retrieve Keys",
    "adpprofile": "Save Profile",
    "adphrcerr1": "Client ID cannot be blank.",
    "adphrcerr2": "Client Secret cannot be blank.",
    "adphrcerr3": "Report ID cannot be blank.",
    "adphrloaderr": "Query failed. Check ADP connector configuration. Click on the '?' for details on configuring the connector.",
    "adphrloaderr2": "Authentication failed. Check ADP connector configuration.",
    "adphrloaderr3": "Bad data returned. Check ADP connector configuration.",
    "adphrloaderr4": "No employee records returned.",
    "adphrloaderr5": "ADP Interface Error:",
    "adphrloaderr6": "Unspecified Error",
    "adpkeymsg": "ADP keys retrieved! You can now use the import wizard to automatically create charts using your ADP Data.",
    "adpkeyhelpmsg": "Click on the '?' for additional help.",
    "adpkeyfail_nooid": "Missing OrganizationID. You must sign up in the ADP Marketplace to retrieve keys.",
    "adpkeyfail_auth": "Internal error. Contract technical support.",
    "adpkeyfail_keyretrieve": "Internal error - unable to retrieve key. Contact technical support.",
    "subscribeHRConfig": "Configure Subscribe-HR Connection",
    "subscribeHRLink2": "Subscribe-HR Company Name",
    "subscribeHRUser1": "User ID:",
    "subscribeHRUser2": "Subscribe-HR User ID",
    "subscribeHRPass1": "Password:",
    "subscribeHRReport1": "Report ID:",
    "subscribeHRReport2": "Enter 0 for basic, 1 for extended",
    "subscribehrcerr2": "User ID cannot be blank.",
    "subscribehrcerr3": "Password cannot be blank.",
    "subscribehrcerr4": "Report ID cannot be blank.",
    "subscribehrloaderr": "Query failed. Check Subscribe-HR connector configuration.",
    "subscribehrloaderr2": "Authenication failed. Check Subscribe-HR connector configuration.",
    "subscribehrloaderr3": "Bad data returned. Check Subscribe-HR connector configuration.",
    "subscribehrloaderr4": "No employee records returned.",
    "ultiproConfig": "Configure UKG Pro Connection",
    "ultiproLink1": "Server",
    "ultiproLink2": "Retrieve from UKG Pro",
    "ultiproUser1": "User Name:",
    "ultiproUser2": "UKG Pro User Name",
    "ultiproPass1": "Password:",
    "ultiproReport1": "Report ID:",
    "ultiproReport2": "Enter 0 for basic, 1 for extended",
    "upuseraccesskey1": "User access key",
    "upuseraccesskey2": "Retrieve from UKG Pro",
    "upclientaccesskey1": "Client access key",
    "upclientaccesskey2": "Retrieve from UKG Pro",
    "ultiprocerr1": "Server link cannot be blank.",
    "ultiprocerr2": "User Access Key cannot be blank.",
    "ultiprocerr3": "Client Access Key cannot be blank.",
    "ultiprocerr4": "User Name cannot be blank.",
    "ultiprocerr5": "Password cannot be blank.",
    "ultiprocerr6": "Report ID cannot be blank.",
    "ultiprocerr7": "Interface must be set to BI, BIT or WS.",
    "ultiprocerr8": "Report Name cannot be blank.",
    "ultiprocerr9": "Report Path cannot be blank.",
    "ultiproloaderr": "Query failed. Check UKG Pro connector configuration.",
    "ultiproloaderr2": "Authentication failed. Check UKG Pro connector configuration.",
    "ultiproloaderr3": "Bad data returned. Check UKG Pro connector configuration.",
    "ultiproloaderr4": "No employee records returned.",
    "ultiproInterface1": "Interface",
    "ultiproInterface2": "Enter BI, BIT or WS",
    "ultiproReportName1": "Report name",
    "ultiproReportName2": "For BI Interface only",
    "ultiproReportPath1": "Report path",
    "ultiproReportPath2": "For BI Interface only (ex: Company_Acme_MyReports)",
    "ultiquery": "Run report as query",
    "sutihrcerr1": "Subdomain cannot be blank.",
    "sutihrcerr2": "API Key cannot be blank.",
    "sutihrcerr3": "User Name cannot be blank.",
    "sutihrcerr4": "Password cannot be blank.",
    "sutihrcerr5": "Report ID cannot be blank.",
    "sutihrloaderr": "Query failed. Check SutiHR connector configuration.",
    "sutihrloaderr2": "Bad data returned. Check connector configuration.",
    "sutihrloaderr3": "No employee records returned.",
    "suticonfig": "Configure SutiHR Connection",
    "sutisub1": "Subdomain:",
    "sutiapi1": "API Key:",
    "sutiapi2": "Generate in SutiHR",
    "sutiuserl": "SutiHR User:",
    "sutiuser2": "User ID",
    "sutipw": "Password:",
    "sutirid1": "Report ID:",
    "sutirid2": "Enter 0 for basic, 1 for extended",
    "salesforcecerr1": "User ID cannot be blank.",
    "salesforcecerr2": "Password cannot be blank.",
    "salesforcecerr3": "Security Token cannot be blank.",
    "salesforcecerr4": "Sandbox value invalid.",
    "salesforcecerr5": "Query cannot be blank.",
    "salesforcecerr6": "Field mapping cannot be blank.",
    "salesforceloaderr": "Query failed. Check Salesforce connector configuration.",
    "salesforceloaderr2": "Bad data returned. Check connector configuration.",
    "salesforceloaderr3": "No records returned.",
    "salesforceConfig": "Configure Salesforce Connection",
    "sfuser": "User ID",
    "sfuser2": "Salesforce User ID",
    "sfpassword": "Password",
    "sfpassword2": "Salesforce Password",
    "sftoken": "Security Token",
    "sftoken2": "Salesforce Security Token",
    "sfsandbox": "Sandbox",
    "notSandbox": "This is not a Sandbox Account",
    "sfsandbox2": "leave blank for production, set to 'true' for sandbox",
    "sfquery": "Query",
    "sfquery2": "Salesforce SOQL Query",
    "sffieldmap": "Field Map",
    "sffieldmap2": "Comma delimited list of desired field names",
    "sfsfConfig": "Configure SuccessFactors Connection",
    "sfsfservice": "Server",
    "sfsfservice2": "SuccessFactors Server Address (Example: api4)",
    "sfsfuser": "User ID",
    "sfsfuser2": "SuccessFactors User ID",
    "sfsfpassword": "Password",
    "sfsfpassword2": "SuccessFactors Password",
    "sfsforg": "Org Code",
    "sfsforg2": "SuccessFactors Organization Code",
    "sfsfadd": "Additional fields:",
    "sfsfadd2": "Specify additional fields to add to query",
    "sfsfreportid": "Report ID:",
    "sfsfreportid2": "Enter 0 for basic, 1 for extended",
    "sfsfresource": "Resource Table",
    "sfsfquerystring": "Query Parameters",
    "sfsfquerystring2": "Enter Query Parameters (Example: &$expand=manager,hr&$orderby=userId)",
    "sfsfcerr0": "Server address cannot be blank.",
    "sfsfcerr1": "User ID cannot be blank.",
    "sfsfcerr2": "Password cannot be blank.",
    "sfsfcerr3": "Org Code cannot be blank.",
    "sfsfcerr4": "Report ID cannot be blank.",
    "sfsfloaderr": "Query failed. Check SuccessFactors connector configuration.",
    "triConfig": "Configure TriNet Connection",
    "tricompany2": "Company Name",
    "triuser": "User ID:",
    "triuser2": "TriNet User ID",
    "tripassword": "Password:",
    "tripassword2": "TriNet Password",
    "triclientid": "Client ID:",
    "triclientid2": "TriNet Client ID",
    "triclientsecret": "Client Secret:",
    "triclientsecret2": "TriNet Client Secret",
    "trireportid": "Report ID:",
    "trireportid2": "Enter 0 for basic, 1 for extended",
    "tricerr1": "User ID cannot be blank.",
    "tricerr2": "Password cannot be blank.",
    "tricerr3": "Client ID cannot be blank.",
    "tricerr4": "Client Secret cannot be blank.",
    "tricerr5": "Report ID cannot be blank.",
    "triloaderr": "Query failed. Check TriNet connector configuration.",
    "orangeConfig": "Configure OrangeHRM Connection",
    "orangesubdomain": "Subdomain:",
    "orangesubdomain2": "subdomain.orangehrm.com",
    "orangeuser": "User ID:",
    "orangeuser2": "OrangeHRM User ID",
    "orangepassword": "Password:",
    "orangepassword2": "OrangeHRM Password",
    "reportID": "Report ID:",
    "orangereportid2": "Enter 0 for basic, 1 for extended",
    "orangecerr0": "Subdomain cannot be blank.",
    "orangecerr1": "User ID cannot be blank.",
    "orangecerr2": "Password cannot be blank.",
    "orangecerr3": "Report ID cannot be blank.",
    "orangeloaderr": "Query failed. Check OrangeHRM connector configuration.",
    "sapxmlConfig": "Configure SAP XML Connection",
    "sapxmlfields": "Additional fields:",
    "sapxmlfields2": "Enter Additional Fields to Query",
    "sapConfig": "Configure SAP RFC Connection",
    "saphost": "Application Server",
    "saphost2": "Enter Host Address",
    "sapclient": "Client",
    "sapclient2": "Enter Client Number",
    "sapsystem": "System Number",
    "sapsystem2": "Enter System Number",
    "sapuser": "SAP User",
    "sapuser2": "Enter SAP Username",
    "sappassword": "SAP Password",
    "sappassword2": "Enter SAP Password",
    "sapviewid": "ViewID",
    "sapviewid2": "Enter ViewID",
    "sapobjectid": "Object ID",
    "sapobjectid2": "Enter Object ID",
    "sapobjecttype": "Object Type",
    "sapobjecttype2": "Enter Object Type",
    "sapparams": "Additional fields",
    "sapparams2": "Enter Additional Fields to Query",
    "sapcerr0": "Application Server cannot be blank.",
    "sapcerr1": "Client number cannot be blank.",
    "sapcerr2": "System number cannot be blank.",
    "sapcerr3": "SAP user cannot be blank.",
    "sapcerr4": "SAP password cannot be blank.",
    "sapcerr5": "ViewID cannot be blank.",
    "sapcerr6": "Object ID cannot be blank.",
    "sapcerr7": "Object type cannot be blank.",
    "saploaderr": "Query failed. Check SAP connector configuration.",
    "namelyConfig": "Configure Namely Connection",
    "namelysubdomain": "Subdomain:",
    "namelysubdomain2": "subdomain.namely.com",
    "namelytoken": "API Token:",
    "namelytoken2": "Generate in your Namely profile",
    "namelyreportid2": "Enter 0 for Standard",
    "namelycerr0": "Subdomain cannot be blank.",
    "namelycerr1": "API token cannot be blank.",
    "namelycerr2": "Report ID cannot be blank.",
    "namelyloaderr": "Query failed. Check Namely connector configuration.",
    "levertoken": "API Token:",
    "levertoken2": "Generate in your Lever profile",
    "leverreqs": "All requisitions",
    "clearcompanyusername2": "Enter username for ClearCompany ATS.",
    "clearcompanypassword2": "Enter password for ClearCompany ATS.",
    "greenhouseConfig": "Configure Greenhouse Connection",
    "greenhousetoken": "API Token:",
    "greenhousetoken2": "Generate in your Greenhouse profile",
    "greenhousetitle": "Job Title:",
    "greenhousetitle2": "Job title maps to?",
    "greenhouseemail": "Email:",
    "greenhouseemail2": "Email maps to?",
    "greenhousedept": "Department:",
    "greenhousedept2": "Department maps to?",
    "greenhousereportid2": "Enter 0 for basic, 1 for extended",
    "greenhousecerr0": "API token cannot be blank.",
    "greenhousecerr1": "Job title cannot be blank.",
    "greenhousecerr2": "Email cannot be blank.",
    "greenhousecerr3": "Department token cannot be blank.",
    "greenhousecerr4": "Report ID cannot be blank.",
    "greenhouseloaderr": "Query failed. Check Greenhouse connector configuration.",
    "greenhousev1label": "Use legacy v1 API (API Key)",
    "greenhouseconnect": "Connect to Greenhouse",
    "greenhousereconnect": "Reconnect to Greenhouse",
    "greenhouseadminreq": "Sign in as a Greenhouse Site Admin to authorize.",
    "greenhouseautherr": "Greenhouse authorization failed. Try connecting again.",
    "payspaceConfig": "Configure Cloud Connection",
    "payspacecompanycode": "Company Code:",
    "payspacecompanycode2": "Enter Company Code",
    "payspaceuser": "User ID:",
    "payspaceuser2": "User ID",
    "payspacepassword": "Password:",
    "payspacepassword2": "Password",
    "payspacereqtype": "Request Type",
    "payspacereqtype2": "EmpDir, JobDir or custom type",
    "payspaceterm": "Term months",
    "payspaceoptions": "Options",
    "payspaceterm2": "Enter 0 to exclude terminated employees",
    "payspacereportid": "Report ID:",
    "payspacereportid2": "Enter 0 for basic, 1 for extended",
    "payspacetogglerest": "Use REST API",
    "sageauthmethodtoggle": "Use username and password authentication",
    "bambootogglelegacy": "Use (Legacy) API Key",
    "payspacecerr0": "Company Code cannot be blank.",
    "payspacecerr1": "User ID cannot be blank.",
    "payspacecerr2": "Password cannot be blank.",
    "payspacecerr3": "Request type cannot be blank.",
    "payspacecerr4": "Termination months cannot be blank.",
    "payspacecerr5": "Report ID cannot be blank.",
    "payspaceloaderr": "Query failed. Check connector configuration.",
    "customloaderr": "Custom query failed.",
    "googleConfig": "Configure Google Directory Connection",
    "googleDomain": "Domain Name:",
    "googleDomain2": "mycompany.com",
    "googleemail": "Email:",
    "googleemail2": "Authorized email account",
    "googlereportid": "Report ID:",
    "googlereportid2": "Enter 0 for basic, 1 for extended",
    "googlecerr0": "Domain cannot be blank.",
    "googlecerr3": "Report ID cannot be blank.",
    "googleloaderr": "Query failed. Check Google connector configuration.",
    "googlecredupload": "Credentials uploaded.",
    "googlecreduploadfail": "Upload failed - contact support.",
    "googleserv1": "Upload Service Account Credentials",
    "googledirloaderr": "Query failed. Check Google Directory connector configuration.",
    "breatheHR1": "Configure breatheHR Connection",
    "breatheHR2": "API Key",
    "breatheHR3": "Generate in breatheHR",
    "breatheHR4": "Query all fields",
    "breatheHR4a": "Enter 0 for basic, 1 for extended",
    "breatheHR5": "Past employees",
    "breathehrcerr1": "API Key cannot be blank.",
    "breathehrcerr2": "Report ID cannot be blank.",
    "breathehrloaderr": "Query failed. Check breatheHR connector configuration.",
    "breathehrloaderr2": "Authentication failed. Check breatheHR connector configuration.",
    "breathehrloaderr3": "Bad data returned. Check breatheHR connector configuration.",
    "breathehrloaderr4": "No employee records returned.",
    "QATS": "Append Greenhouse ATS Data",
    "activedirConfig": "Configure Active Directory Connection",
    "activedirmsg": "In order to extract data from Active Directory, a small software package must be installed on a server within your network. Click on the '?' for more information.",
    "authsuccess": "Authentication Test: Success",
    "authfailure": "Authentication Test: Failure",
    "uf_usertype_err": "Invalid user type in userfeed.txt",
    "uf_filenotfound_err": "Unable to find or load userfeed file",
    "uf_userexists_err": "User record in use by another account.",
    "uf_badgroup_err": "Invalid access group",
    "uf_invaliduser": "Invalid user or email found in userfeed.txt",
    "uf_usernotfound": "Current user not found in userfeed.txt",
    "dynloaderr1": "No data returned. Contact technical support. Error Code DC01.",
    "dynloaderr2": "No data returned. Contact technical support. Error Code DC02.",
    "dynloaderr3": "Query failed. Contact technical support. Error Code DC03.",
    "azureConfig": "Configure AzureAD Connection",
    "azuremsg": "Please contact technical support for help extracting data from your AzureAD instance.",
    "customConfig": "Configure Custom Connection",
    "custommsg": "Please contact technical support for help extracting data from your Custom instance.",
    "workdayConfig": "Configure Workday Connection",
    "workdaymsg": "Please contact technical support for help extracting data from your Workday account.",
    "jobviteConfig": "Configure Jobvite Connection",
    "jobvitekey": "API Key:",
    "jobvitekey2": "Generate in your Jobvite profile",
    "jobvitesecret": "API Secret:",
    "jobvitesecret2": "Generate in your Jobvite profile",
    "jobvitetitle": "Job Title:",
    "jobvitetitle2": "Job Title maps to?",
    "jobvitedept": "Department:",
    "jobvitedept2": "Department maps to?",
    "reportid2": "Enter 0 for Standard",
    "ATS": "ATS",
    "ADPProf": "Profile:",
    "icimsConfig": "Configure iCIMS Connection",
    "icimsuser": "User:",
    "icimsuser2": "Received from your iCIMS integration specialist",
    "icimspwd": "Password:",
    "icimspwd2": "Received from your iCIMS integration specialist",
    "icimscusid": "Customer ID:",
    "icimscusid2": "Your iCIMS Customer ID",
    "icimstitle": "Job Title:",
    "icimstitle2": "Job Title maps to?",
    "icimsdept": "Department:",
    "icimsdept2": "Department maps to?",
    "icimscerr0": "User cannot be blank.",
    "icimscerr2": "Customer ID cannot be blank",
    "icimscerr3": "Job title cannot be blank.",
    "icimscerr1": "Password cannot be blank.",
    "icimscerr4": "Department token cannot be blank.",
    "icimscerr5": "Report ID cannot be blank.",
    "jobvitecerr0": "API Key cannot be blank.",
    "jobvitecerr2": "Job title cannot be blank.",
    "jobvitecerr1": "API Secret cannot be blank.",
    "jobvitecerr3": "Department token cannot be blank.",
    "jobvitecerr4": "Report ID cannot be blank.",
    "jobviteloaderr": "Query failed. Check Jobvite connector configuration.",
    "workdayapiuser": "API User",
    "workdayapiuser2": "The user given permission to access Workday",
    "workdayendpoint": "Workday Endpoint",
    "workdayendpoint2": "The Endpoint of the RaaS you generated",
    "workdaypassword": "API Password",
    "workdaypassword2": "The API Users Password",
    "workdaycerr0": "API User cannot be blank.",
    "workdaycerr1": "Workday User cannot be blank",
    "workdaycerr2": "Password cannot be blank.",
    "workdaycerr4": "ReportID token cannot be blank.",
    "Leave blank to match subdomain": "Leave blank to match subdomain",
    "signifytoken2": "The API token generated in Signify",
    "Photo URL": "Photo URL",
    "signifycerr0": "The token cannot be blank",
    "signifyconfig": "Configure Signify Connection",
    "Email Field": "Email Field",
    "Hiring Manager": "Hiring Manager",
    "Separate Job Reqs": "Separate boxes for each open job requisition",
    "Req Count Field1": "Req Count Field",
    "Req Count Field2": "Enter requisition count field from ATS data",
    "Custom Search": "Custom Search",
    "dfstatus1": "Active Statuses",
    "dfstatus2": "Active Status Codes (optional)",
    "Inactive Statuses": "Inactive Statuses",
    "dfidprefix": "Employee ID prefix",
    "dfidprefixhelper": "Added to employee and manager IDs from this source. Use when two Dayforce environments reuse the same employee numbers.",
    "Child resources": "Child resources",
    "Child resources helper": "workRelationships.assignments, names",
    "Finder": "Finder",
    "Finder helper": "Query using pre-defined finder (e.g. 'findByPersonId')",
    "limitlabel": "Records per request",
    "limithelper": "Number of records to fetch per API call (default 250, max 500)",
    "Parameters": "Parameters",
    "Parameters helper": "Query Parameter (e.g. 'workRelationships.TerminationDate is null')",
    "Custom Base Profile": "Custom Base Profile",
    "genericfilter1": "Filter",
    "genericfilter2": "Enter filter",
    "genericadditionalfields1": "Additional fields",
    "genericadditionalfields2": "Enter additional fields",
    "genericaccountname1": "Account name",
    "genericaccountname2": "Enter account name",
    "genericrefreshtoken1": "Refresh token",
    "genericrefreshtoken2": "Enter API refresh token",
    "paycorsubkey1": "Subscription key",
    "paycorsubkey2": "Enter Paycor subscription key",
    "paycorlegentityid1": "Legal entity ID",
    "paycorlegentityid2": "Enter Paycor legal entity ID",
    "genericclientcode1": "Client code",
    "genericclientcode2": "Enter client code",
    "genericschemaid1": "Schema ID",
    "genericschemaid2": "Enter Schema ID",
    "othLoginUrl": "eywpLoginUrl",
    "PaycomIP":"Contact your Paycom administrator to whitelist the following IP address",
    "PaycomHelp":"Paycom requires you to whitelist any IP addresses you plan to access the API from",
    "Source ID":"Source ID",
    "Generating...":"Generating...",
    "Loading...":"Loading...",
    "Loading existing key...":"Loading existing key...",
    "Regenerate API Key":"Regenerate API Key",
    "Generate API Key":"Generate API Key",
    "API key configured":"API key configured",
    "No API key generated":"No API key generated",
    "API key generated successfully":"API key generated successfully",
    "Failed to generate API key":"Failed to generate API key",
    "View or regenerate the API key used for this integration. If you regenerate the key, remember to update it in your external application to maintain connectivity. " : "View or regenerate the API key used for this integration. If you regenerate the key, remember to update it in your external application to maintain connectivity. {linkText}",
    "Click here to find documentation.": "Click here to find documentation.",
    "An error occurred. Please try again.":"An error occurred. Please try again.",
    "resourceId": "Resource ID",
    "resourceId2": "Enter the Azure AD resource ID"

}
